module.exports = __webpack_public_path__ + "media/images/quick_search/format/img_4-e44e51cedaa44ae5516c8917facb22a8.png";